var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/img/logo.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }